import styled from "styled-components";

const PageTitle = styled.div`
  font-family: ${(props) => props.theme.fonts.mainBoldFont};
  color: ${(props) => props.theme.colors.primaryBlack};
  font-size: ${(props) => props.theme.fontSizes.heading3FontSize};
`;

export default PageTitle;
